"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var constants_1 = require("../constants");

var isAddressField = R.allPass([R.propEq('fieldType', constants_1.FIELD_TYPE.SMART), R.pathEq(['fieldTypeAttributes', 'format'], constants_1.SMART_FORMATS.ADDRESS)]);
exports.isAddressField = isAddressField;